import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"; //eslint-disable-line
import styled from "@emotion/styled";

import Sermons from "./pages/Sermons.js";
import MinistryTeam from "./pages/MinistryTeam.js";
import AllEvents from "./pages/AllEvents.js";

//Ministry pages
import YouthMinistry from "./pages/YouthMinistry.js";
import ChildrensMinistry from "./pages/ChildrensMinistry.js";
import ConnectGroups from "./pages/ConnectGroups.js";
import MercyMinistry from "./pages/MercyMinistry.js";
import PastoralCare from "./pages/PastoralCare.js";
import Prayer from "./pages/Prayer.js";
import LittleSquirts from "./pages/LittleSquirts.js";
import EnglishHub from "./pages/EnglishHub.js";

//Support pages
import SupportUs from "./pages/SupportUs.js";
import MissionsWeSupport from "./pages/MissionsWeSupport.js";

//Resources
import Resources from "./pages/Resources.js";

//Welcome pages
import BecomingAPartner from "./pages/BecomingAPartner.js";
import ChristianityExplored from "./pages/ChristianityExplored.js";
import WelcomeToChurch from "./pages/WelcomeToChurch.js";

//Other pages
import MemberInfo from "./pages/MemberInfo.js";
import NotFound from "./pages/NotFound.js";
import ParentingArticles from "./pages/parentingarticles/ParentingArticles.js";
import ParentingArticle from "./pages/parentingarticles/ParentingArticle.js";

//Webforms
import MorphCamp from "./pages/webforms/MorphCamp.js";
import ContactForm from "./pages/ConnectionCard.js";
import LanternLaunchPlaceholder from "./pages/events/LanternLaunchPlaceholder.js";

//events
// import Gingerbread from "./pages/events/Gingerbread.js";

const WrapperDiv = styled.div`
	section {
		padding-top: 10px;
		padding-bottom: 30px;
	}
`;

class OtherPageWrapper extends Component {
	render() {
		return (
			<section>
				<WrapperDiv id="wrapper">
					<Switch>
						<Route exact path="/Sermons" component={Sermons} />
						<Route exact path="/MinistryTeam" component={MinistryTeam} />
						<Route exact path="/Events" component={AllEvents} />
						<Route exact path="/YouthMinistry" component={YouthMinistry} />
						<Route exact path="/ChildrensMinistry" component={ChildrensMinistry} />
						<Route exact path="/ConnectGroups" component={ConnectGroups} />
						<Route exact path="/MercyMinistry" component={MercyMinistry} />
						<Route exact path="/PastoralCare" component={PastoralCare} />
						<Route exact path="/Prayer" component={Prayer} />
						<Route exact path="/SupportUs" component={SupportUs} />
						<Route exact path="/MissionsWeSupport" component={MissionsWeSupport} />
						<Route exact path="/Resources" component={Resources} />
						<Route exact path="/LittleSquirts" component={LittleSquirts} />
						<Route exact path="/EnglishHub" component={EnglishHub} />
						<Route exact path="/BecomingAPartner" component={BecomingAPartner} />
						<Route exact path="/ChristianityExplored" component={ChristianityExplored} />
						<Route exact path="/WelcomeToChurch" component={WelcomeToChurch} />
						<Route exact path="/MemberInfo" component={MemberInfo} />
						<Route exact path="/ParentingArticles" component={ParentingArticles} />
						<Route exact path="/ParentingArticle/:nid" component={ParentingArticle} />
						<Route exact path="/ParentingArticle/:nid/:title" component={ParentingArticle} />
						<Route exact path="/MorphCamp" component={MorphCamp} />
						<Route exact path="/Connect" component={ContactForm} />
						<Route exact path="/events/LanternCentreLaunch" component={LanternLaunchPlaceholder} />
						<Route path="/*" component={NotFound} />
					</Switch>
				</WrapperDiv>
			</section>
		);
	}
}

export default OtherPageWrapper;
